import React from "react";
import { Search, X } from "lucide-react";

const DIVISIONS = [
    { value: "all", label: "All Divisions" },
    { value: "funding", label: "Funding" },
    { value: "realestate", label: "Real Estate" },
    { value: "materials", label: "Materials" },
    { value: "consulting", label: "Consulting" },
    { value: "contact", label: "Contact" },
];

const STATUSES = [
    { value: "all", label: "All Statuses" },
    { value: "new", label: "New" },
    { value: "contacted", label: "Contacted" },
    { value: "qualified", label: "Qualified" },
    { value: "not_qualified", label: "Not Qualified" },
    { value: "closed", label: "Closed" },
    { value: "archived", label: "Archived" },
];

const baseSelectCls =
    "appearance-none rounded-lg border border-border-subtle bg-[var(--bg-elevated-2)] px-3 py-2 text-[13.5px] text-text-primary focus:outline-none focus:border-[rgba(124,255,79,0.55)]";

export const LeadFilters = ({
    division,
    status,
    search,
    onDivisionChange,
    onStatusChange,
    onSearchChange,
    onClear,
    showingFrom,
    showingTo,
    total,
}) => {
    const anyActive =
        division !== "all" || status !== "all" || (search && search.length > 0);
    return (
        <div
            className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
            data-testid="lead-filters"
        >
            <div className="flex flex-wrap items-center gap-3">
                <select
                    value={division}
                    onChange={(e) => onDivisionChange(e.target.value)}
                    data-testid="filter-division"
                    className={baseSelectCls}
                >
                    {DIVISIONS.map((d) => (
                        <option key={d.value} value={d.value}>
                            {d.label}
                        </option>
                    ))}
                </select>
                <select
                    value={status}
                    onChange={(e) => onStatusChange(e.target.value)}
                    data-testid="filter-status"
                    className={baseSelectCls}
                >
                    {STATUSES.map((s) => (
                        <option key={s.value} value={s.value}>
                            {s.label}
                        </option>
                    ))}
                </select>
                <div className="relative">
                    <Search
                        className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-text-muted"
                        strokeWidth={1.75}
                    />
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => onSearchChange(e.target.value)}
                        placeholder="Search name, email, business…"
                        data-testid="filter-search"
                        className="rounded-lg border border-border-subtle bg-[var(--bg-elevated-2)] px-3 py-2 pl-9 text-[13.5px] text-text-primary placeholder:text-text-muted focus:outline-none focus:border-[rgba(124,255,79,0.55)] w-64"
                    />
                </div>
                {anyActive && (
                    <button
                        type="button"
                        onClick={onClear}
                        data-testid="filter-clear"
                        className="inline-flex items-center gap-1.5 rounded-lg border border-border-subtle px-3 py-2 text-[13px] text-text-secondary hover:text-text-primary hover:border-border-default"
                    >
                        <X className="h-3.5 w-3.5" strokeWidth={1.75} />
                        Clear
                    </button>
                )}
            </div>
            <p
                className="text-[12.5px] text-text-muted tabular-nums"
                data-testid="filter-counts"
            >
                Showing {showingFrom}–{showingTo} of {total} leads
            </p>
        </div>
    );
};

export default LeadFilters;
